<div class="grid grid-rows-3 gap-4">
    <div class="row-span-3">
        <filter (teacherListVisible)="teacherListVisible($event)"></filter>
    </div>
</div>